import React from 'react';
import { ArrowRight, HeartHandshake, ShieldCheck, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Sparkles,
  label: 'Eight archetypes',
  detail: 'A memorable language for your patterns'
}, {
  icon: ShieldCheck,
  label: 'Private reflection',
  detail: 'A thoughtful place to begin'
}, {
  icon: HeartHandshake,
  label: 'Practical insight',
  detail: 'Understand how you connect and protect'
}];
export function AssessmentSpotlight() {
  return <section id="assessment" className="py-20 md:py-28 bg-brand-800 text-white scroll-mt-20" data-id="element-6" data-mp="2zf6x5ij6t39m">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7" data-mp="3dezieyby2ra7">
        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-12 lg:gap-20 items-center" data-id="element-8" data-mp="3dcdct48m6lum">
          <div data-id="element-9" data-mp="38hg45yf8yei9">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent-300 mb-5" data-id="element-10" data-mp="38hprtfctk9ks">
              A practical place to begin
            </p>
            <h2 className="text-4xl md:text-5xl font-title font-bold text-white leading-tight max-w-2xl" data-id="element-11" data-mp="nocnce9sklin">
              What’s your Relationship Animal?
            </h2>
            <p className="mt-6 text-lg md:text-xl leading-relaxed text-brand-100 max-w-2xl" data-id="element-12" data-mp="2ua7hb884ufk8">
              Discover the relationship pattern that shapes how you connect,
              protect yourself, and love. The assessment gives you a clear,
              memorable starting point for understanding yourself and the people
              closest to you.
            </p>
            <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-5" data-id="element-13" data-mp="2bk90a2mcxc4g">
              <a href="#" className="inline-flex justify-center items-center px-7 py-4 bg-accent-500 text-white rounded-full font-semibold hover:bg-accent-600 transition-all hover:shadow-lg hover:-translate-y-0.5" data-id="element-14" data-mp="2bi51fz3bf3b1">
                Take the Assessment
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-15" data-mp="1nske7404pjvy" />
              </a>
              <a href="#therapy" className="inline-flex items-center justify-center text-white font-semibold hover:text-accent-200 transition-colors" data-id="element-16" data-mp="1ssgh0zx3b59x">
                Prefer to start with therapy?
                <ArrowRight className="ml-2 h-4 w-4" data-id="element-17" data-mp="1uivdrvm0c8bi" />
              </a>
            </div>
          </div>

          <div className="grid gap-4" data-id="element-18" data-mp="1pk20a36q0hbc">
            {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return <div key={benefit.label} className="flex items-center gap-5 rounded-2xl border border-white/15 bg-white/10 p-5 backdrop-blur-sm" data-id="element-19" data-mp="11uprh4fb2b9k" data-mpi={index}>
                  <div className="w-11 h-11 rounded-xl bg-accent-500 text-white flex items-center justify-center shrink-0" data-id="element-20" data-mp="1btyhjm71v5qn">
                    <Icon className="h-5 w-5" data-id="element-21" data-mp="16vn99fwel3aj" />
                  </div>
                  <div data-id="element-22" data-mp="2n5zdpm68twgf">
                    <p className="font-semibold text-white" data-id="element-23" data-mp="2n9dfotazw3nc">{benefit.label}</p>
                    <p className="text-sm text-brand-100 mt-1" data-id="element-24" data-mp="2i8692xkl9ai9">{benefit.detail}</p>
                  </div>
                  <span className="ml-auto font-title font-bold text-2xl text-white/30" aria-hidden="true" data-id="element-25" data-mp="2pqno1jb8hhim">
                    0{index + 1}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}